import * as Util from "../Utils/Util";
import DomFactory from "../Utils/DomFactory";
import Events from "../Utils/Events";
import ButtonMarker from "../Utils/ButtonMarker";
import ProductState from "./ProductState";

export default class SubscriptionFrequencyButton {
  private readonly element: HTMLElement;
  private readonly subscriptionOn: boolean;

  public constructor(element: HTMLElement) {
    this.element = element;
    this.subscriptionOn = Util.getData(element, "subscriptionOn") === "true";
    element.addEventListener("click", () => this.send());
    Events.on("product-state-change", (s: ProductState) => ButtonMarker.mark(element, this.isActive(s)));
  }

  private isActive(s: ProductState): boolean {
    return (this.subscriptionOn && !!s.frequency) || (!this.subscriptionOn && !s.frequency);
  }

  private send(): void {
    Events.fire("subscription-toggled", this.subscriptionOn);
  }

  public static Factory: DomFactory<SubscriptionFrequencyButton> = (e) => new SubscriptionFrequencyButton(e);
}
